// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/contador/contadorClient.ts
//  Sessão e cliente HTTP do Portal do Contador. Separados da sessão do ERP de
//  propósito: o contador não é usuário de nenhum cliente, o token dele não abre
//  rota do ERP (audience própria na API) e as duas sessões convivem no navegador.
// ════════════════════════════════════════════════════════════════════════════

import axios from 'axios';

const BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:5000';
const CHAVE_TOKEN = 'udisys_contador_token';
const CHAVE_USUARIO = 'udisys_contador_usuario';

export interface ContadorUsuario {
  id: number;
  nome: string;
  email: string;
  papel: string;
  escritorio: { id: number; razaoSocial: string; cnpjCpf?: string | null };
}

export const sessaoContador = {
  token: () => localStorage.getItem(CHAVE_TOKEN),
  usuario: (): ContadorUsuario | null => {
    try {
      const bruto = localStorage.getItem(CHAVE_USUARIO);
      return bruto ? (JSON.parse(bruto) as ContadorUsuario) : null;
    } catch {
      return null;
    }
  },
  salvar: (token: string, usuario: ContadorUsuario) => {
    localStorage.setItem(CHAVE_TOKEN, token);
    localStorage.setItem(CHAVE_USUARIO, JSON.stringify(usuario));
  },
  sair: () => {
    localStorage.removeItem(CHAVE_TOKEN);
    localStorage.removeItem(CHAVE_USUARIO);
  },
};

export const contadorClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 60_000,
});

contadorClient.interceptors.request.use((config) => {
  const token = sessaoContador.token();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401 fora do login: a sessão do portal venceu (12 h) — volta para a entrada do portal.
contadorClient.interceptors.response.use(
  (r) => r,
  (error) => {
    const naEntrada = error.config?.url?.startsWith('/api/contador/auth/');
    if (error.response?.status === 401 && !naEntrada) {
      sessaoContador.sair();
      window.location.href = '/contador/entrar';
    }
    if (error.response?.data?.mensagem) error.message = error.response.data.mensagem;
    return Promise.reject(error);
  },
);
